import React, { useRef, useState } from "react";
import Navbar from "../../components/Navbar";
import Reset_Password from "../../assets/auth/reset-password.png";
import pass_on from "../../assets/auth/pass-on.png";
import pass_off from "../../assets/auth/pass-off.png";
import Close_Button from "../../assets/auth/close.png";
import Styles from "../../styles/client/changepassword.module.scss";
import { changeClientPasswordService } from "../../services";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { clientRoutes } from "../../routers/ClientRouters";
import { Link, useNavigate } from "react-router-dom";

const ChangePassword = () => {
  const navigate = useNavigate();
  let currentPasswordRef = useRef("");
  let newPasswordRef = useRef("");
  let confirmPasswordRef = useRef("");

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const dispatch = useDispatch();

  const handleCancel = () => {
    navigate(-1); // Go back to previous page
  };

  // Real-time password validation
  const handleNewPasswordChange = (e) => {
    const value = e.target.value;
    setNewPassword(value);
    newPasswordRef.current.value = value;

    // Check if confirm password field has value and validate
    if (confirmPassword && value !== confirmPassword) {
      setPasswordError("Passwords do not match");
    } else if (confirmPassword && value === confirmPassword) {
      setPasswordError("");
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
    confirmPasswordRef.current.value = value;

    // Validate immediately if both fields have values
    if (newPassword && value && newPassword !== value) {
      setPasswordError("Passwords do not match");
    } else if (newPassword && value && newPassword === value) {
      setPasswordError("");
    } else if (!value) {
      setPasswordError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate passwords match
    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return; // Prevent form submission, show only inline error
    }

    // Clear any existing password errors
    setPasswordError("");

    const success = await changeClientPasswordService(
      currentPasswordRef.current?.value,
      newPassword
    );

    if (success) {
      Swal.fire({
        html: `
          <div style="text-align: center; border-radius: 20px; position: relative; font-family: 'gothambold', sans-serif;">
            <button 
              id="customCloseButton" 
              style="position: absolute; top: -10px; right: -20px; background: none; border: none; cursor: pointer;">
              <img 
                src=${Close_Button} 
                alt="Close" 
                style="width: 50px; height: 50px;"
              />
            </button>
            <img 
              src=${Reset_Password} 
              alt="Success" 
              style="width: 100px; margin-bottom: 20px; margin-top: 30px;" 
            />
            <h2 style="margin: 0; font-family: 'gothambold', sans-serif;">Password Changed!</h2>
            <br/>
            <p style="font-family: 'Gotham Book', sans-serif;">
              You've successfully completed your password change.
            </p>
            <br/>
            <button 
              id="okButton" 
              style="
                background: linear-gradient(0deg, #151515 0%, #525252 100%); 
                color: #f3f3f6; 
                padding: 10px 30px; 
                border: none; 
                border-radius: 5px; 
                cursor: pointer; 
                margin-top: 20px; 
                font-family: 'gothambold', sans-serif;
              ">
              Close
            </button>
          </div>
        `,
        showConfirmButton: false,
        customClass: {
          popup: "custom-swal-container",
        },
        didOpen: () => {
          const thanksButton = document.getElementById("okButton");
          thanksButton.addEventListener("click", () => {
            Swal.close();
            navigate(-1);
          });
        },
      });
    }
  };

  return (
    <div className={Styles.exercise_list_container_main}>
      <Navbar />

      {/* Breadcrumb and Title */}
      <h2>
        <Link to={clientRoutes.dashboard}>HOME / </Link>
        PROFILE / <span>EDIT PROFILE</span>
      </h2>

      <div className={Styles.exercise_list_container}>
        <div className={Styles.table_container_heading}>
          <div className={Styles.table_container_headingone}>
            <h3>CHANGE PASSWORD</h3>
          </div>
        </div>

        <div className={Styles.borderbottomline}></div>

        <div className={Styles.renderedcontentmaindiv}>
          <form
            className={Styles.profile_form}
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div className={Styles.form_grid}>
              {/* Current Password Field */}
              <div className={Styles.form_field}>
                <label className={Styles.field_label}>Current Password</label>
                <div className={Styles.password_field_container}>
                  <input
                    className={Styles.form_input}
                    placeholder="• • • • • • • •"
                    name="currentPassword"
                    minLength={6}
                    maxLength={50}
                    ref={currentPasswordRef}
                    type={showCurrentPassword ? "text" : "password"}
                    required
                  />
                  <div
                    onClick={() => setShowCurrentPassword(!showCurrentPassword)}
                    className={Styles.password_toggle}
                  >
                    <img
                      src={showCurrentPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                    />
                  </div>
                </div>
              </div>

              {/* New Password Field */}
              <div className={Styles.form_field}>
                <label className={Styles.field_label}>New Password</label>
                <div className={Styles.password_field_container}>
                  <input
                    className={Styles.form_input}
                    placeholder="• • • • • • • •"
                    name="newPassword"
                    minLength={6}
                    maxLength={50}
                    ref={newPasswordRef}
                    type={showNewPassword ? "text" : "password"}
                    onChange={handleNewPasswordChange}
                    required
                  />
                  <div
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    className={Styles.password_toggle}
                  >
                    <img
                      src={showNewPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                    />
                  </div>
                </div>
              </div>

              {/* Confirm Password Field */}
              <div className={Styles.form_field}>
                <label className={Styles.field_label}>Confirm Password</label>
                <div className={Styles.password_field_container}>
                  <input
                    className={`${Styles.form_input} ${
                      passwordError ? Styles.error_input : ""
                    }`}
                    placeholder="• • • • • • • •"
                    name="confirmPassword"
                    minLength={6}
                    maxLength={50}
                    ref={confirmPasswordRef}
                    type={showConfirmPassword ? "text" : "password"}
                    onChange={handleConfirmPasswordChange}
                    required
                  />
                  <div
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    className={Styles.password_toggle}
                  >
                    <img
                      src={showConfirmPassword ? pass_on : pass_off}
                      alt="Toggle password visibility"
                    />
                  </div>
                </div>
                {passwordError && (
                  <div className={Styles.error_message}>{passwordError}</div>
                )}
              </div>
            </div>
            <div className={Styles.borderbottomline}></div>

            {/* Button Group */}
            <div className={Styles.button_group}>
              <button type="submit" className={Styles.save_button}>
                Submit
              </button>
              <button
                type="button"
                className={Styles.cancel_button}
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
